import React from 'react';
import HeroSection from "./Home/HeroSection/HeroSection";
import OurProduct from "./Home/OurProduct/OurProduct";
import WhatWeProvide from "./Home/WhatWeProvide/WhatWeProvide";
import SourceCode from "./Home/SourceCode/SourceCode";
import AdComponent from "../Component/AdComponent/AdComponent";
import {Helmet} from "react-helmet";

const Home = () => {
	return (
		<>
			<Helmet>
				<meta charSet="utf-8" />
				<title>SuperCodingBits | React Projects & Source Code</title>
				<meta
					name="description"
					content="SuperCodingBits provides high-quality React.js and frontend development projects with complete source code. Explore UI components, templates, and coding resources to boost your skills."
				/>
				<meta
					name="keywords"
					content="SuperCodingBits, React JS Projects, React Templates, Frontend Development, JavaScript, Source Code, UI Components, Web Development, React Native, SCSS, Coding Resources"
				/>
				<meta name="viewport" content="width=device-width, initial-scale=1.0" />
				<meta name="robots" content="index, follow" />
				<link rel="canonical" href="https://supercodingbitsweb.vercel.app/" />
				
				{/* Open Graph (Facebook, LinkedIn, etc.) */}
				<meta property="og:title" content="SuperCodingBits | React Projects & Source Code" />
				<meta property="og:description" content="Get premium React.js projects, frontend templates, and source code at SuperCodingBits. Perfect for developers and learners." />
				<meta property="og:type" content="website" />
				<meta property="og:url" content="https://supercodingbitsweb.vercel.app/" />
				<meta property="og:image" content="https://supercodingbitsweb.vercel.app/preview-image.jpg" />
				
				{/* Twitter Card */}
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:title" content="SuperCodingBits | React Projects & Source Code" />
				<meta name="twitter:description" content="Explore React.js projects, templates, and source code to improve your frontend development skills with SuperCodingBits." />
				<meta name="twitter:image" content="https://supercodingbitsweb.vercel.app/preview-image.jpg" />
			</Helmet>
			<HeroSection/>
			<OurProduct/>
			<AdComponent />
			{/*<WhatWeProvide/>*/}
			<SourceCode/>
		</>
	);
};

export default Home;